/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type DataImportProjectReviewStatus =
  | 'DataApproval'
  | 'DataInput'
  | 'Done'
  | 'ERComposition'
  | 'EvidenceImport'
  | 'Inbox'
  | 'Planning';

export type DataImportProjectUpdateInput = {
  description?: string | null | undefined;
  documentUrl?: string | null | undefined;
  id: string;
  name?: string | null | undefined;
  referenceIds?: Array<string> | null | undefined;
  statusId?: DataImportProjectReviewStatus | null | undefined;
  tenantId: string;
  userIds?: Array<string> | null | undefined;
};

export type UpdateDataImportProjectMutationVariables = Exact<{
  input: Types.DataImportProjectUpdateInput;
}>;


export type UpdateDataImportProjectMutation = { cnutUpdateDataImportProject: { __typename: 'DataImportProjectUpdateOutput', id: string } };


export const UpdateDataImportProjectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDataImportProject"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DataImportProjectUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateDataImportProject"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDataImportProjectMutation, UpdateDataImportProjectMutationVariables>;